import { environment } from '../../environments/environment';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

@Injectable()
export class LogoManagementService {
  constructor(private http: HttpClient) {
  }

  GetExternalContactLogoList(): Observable<any> {
    return this.http.get(environment.APIEndpoint + 'api/LogoIconMgmt/GetLogoCategory'
      // , { headers: this.getHeader.getHttpHeaders() }
    )
      .pipe(map((data) => data),
        catchError(this.handleError));
  }
  private handleError(error: Response) {
    console.error(error);
    return throwError(error || 'Server error');
  }
}
